<section>
  <mat-checkbox data-cy="dashboard-value-toggle-header" [(ngModel)]="data.showHeader">
    {{ 'DASHBOARD.SHOW_HEADER' | translate }}
  </mat-checkbox>
</section>

@if (data.showHeader) {
  <section>
    <app-emu-input
      data-cy="dashboard-value-header"
      name="{{ 'DASHBOARD.HEADER' | translate }}"
      placeholder="{{ 'DEFAULT' | translate }}"
      [(value)]="data.header"
      [className]="'dashboard-settings'"
    ></app-emu-input>
  </section>
}

<app-selecting-value-data [data]="anyData"></app-selecting-value-data>

<section>
  <app-emu-list-input
    data-cy="dashboard-value-range"
    [(value)]="data.rangeMode"
    [name]="'DASHBOARD.VALUE_RANGE'"
    [filteredOptions$]="of(ranges)"
    [clearButtonHidden]="true"
    [className]="'dashboard-settings'"
  >
    <ng-template let-item
      ><p>{{ getRangeString(item) | translate }}</p></ng-template
    >
  </app-emu-list-input>

  @if (data.rangeMode === DataDisplayDefaultRanges.CUSTOM) {
    <!--        [disabled]="rangePickDisabled"-->
    <app-range-picker [mod]="1" [currentRange]="getRange()" (rangeHasChanged)="changeRange($event)">
    </app-range-picker>
  }
</section>

<section>
  <app-emu-list-input
    data-cy="dashboard-value-mode"
    [(value)]="data.mode"
    [name]="'DASHBOARD.MODE'"
    [filteredOptions$]="of(modes)"
    [clearButtonHidden]="true"
    [className]="'dashboard-settings'"
  >
    <ng-template let-item
      ><p>{{ getModeString(item) | translate }}</p></ng-template
    >
  </app-emu-list-input>
</section>

@if (data.unit) {
  <section>
    <mat-checkbox data-cy="dashboard-value-unit" [(ngModel)]="data.showUnit">
      {{ 'DASHBOARD.SHOW_UNIT' | translate }}
    </mat-checkbox>
  </section>
  @if (data.showUnit) {
    <app-emu-list-input
      data-cy="dashboard-value-prefix"
      [(value)]="data.unit"
      [name]="'VALUE_UNIT'"
      [valueFnc]="transformValue.bind(this)"
      [clearButtonHidden]="true"
      (valueChange)="onUnitChange(data, $event)"
      [filteredOptions$]="of(getUnitsForSeries(data))"
      [className]="'dashboard-settings'"
    >
      <ng-template let-item
        ><p>{{ item?.unit ?? '' }}</p></ng-template
      >
    </app-emu-list-input>
  }
}

<section>
  <mat-checkbox data-cy="dashboard-value-date" [(ngModel)]="data.showDate">
    {{ 'DASHBOARD.SHOW_DATE' | translate }}
  </mat-checkbox>
</section>

<section>
  <mat-slider
    data-cy="dashboard-value-decimal-points"
    [min]="0"
    [max]="8"
    [step]="1"
    [displayWith]="formatLabel"
    discrete
  >
    <span style="width: 100px"
      >{{ 'DASHBOARD.DECIMAL_POINTS' | translate }} : {{ data.decimalPlaces }}</span
    >
    <input matSliderThumb [(ngModel)]="data.decimalPlaces" />
  </mat-slider>
</section>
